/* eslint-disable no-underscore-dangle */

'use strict';

const onOptionUpdate = ({ optionsMsrpHash, option: optionUuid }) => {
  const setOptionMsrp = uuid => {
    const msrpLabel = document.querySelector('.source-metadata-label');
    /**
     * We need msrpContainer and msrpTooltip to make code compatible with
     * refresh left align msrp label
     */
    const msrpContainer = document.querySelector('.msrp-container');
    const msrpTooltip = document.querySelector('.msrp-tooltip-trigger');

    const optionMsrp = optionsMsrpHash[uuid];
    if (msrpLabel && msrpContainer && msrpTooltip) {
      if (optionMsrp) {
        const { description, label } = optionMsrp;
        msrpLabel.innerHTML = label;
        msrpContainer.style.display = 'flex';
        if (msrpTooltip._tippy) {
          msrpTooltip._tippy.setContent(description);
          msrpTooltip._tippy.enable();
        }
      } else {
        msrpLabel.innerHTML = '';
        msrpContainer.style.display = 'none';
        if (msrpTooltip._tippy) {
          msrpTooltip._tippy.setContent('');
          msrpTooltip._tippy.disable();
        }
      }
    }
  };

  window.DealEventPipe.on('goodsOptionUpdate', ({ uuid }) => {
    setOptionMsrp(uuid);
  });

  setOptionMsrp(optionUuid);
};

const MSRP = {
  init({ msrp }, done) {
    if (!msrp) {
      return done();
    }

    onOptionUpdate(msrp);

    return done();
  },
};

module.exports = MSRP;
